module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-rustic-2-4e20da2b6ef146a3927889013fd9fe0a.webp";